import clsx from 'clsx';
import { Navigate, NavLink, Route, Routes } from 'react-router-dom';
import { Panel } from '../../components/panels/Panel';
import { VeralliaDashboardDetections } from './verallia-components/VeralliaDashboardDetections';
import { VeralliaDashboardLastShiftReport } from './verallia-components/VeralliaDashboardLastShiftReport';
import { VeralliaDashboardStatistics } from './verallia-components/VeralliaDashboardStatistics';
import { VeralliaDashboardDefectCatalogue } from './verallia-components/VeralliaDashboardDefectCatalogue';

const MENU_ITEMS = [
  {
    label: 'Detections',
    path: 'detections',
  },
  {
    label: 'Last shift report',
    path: 'last-shift-report',
  },
  {
    label: 'Statistics',
    path: 'statistics',
  },
  {
    label: 'Defect catalogue',
    path: 'defect-catalogue',
  },
];

export const VeralliaDashboard = () => {
  return (
    <div className="flex h-full bg-perception-black-900">
      <Panel
        noHeader
        noPadding
        category="main"
        width="w-60"
        overflowAuto={false}
        className="shrink-0 border-r border-perception-black-500"
      >
        <div className="flex h-full flex-col p-3">
          <div className="px-3 py-4 text-xs font-semibold uppercase tracking-wider text-perception-gray-600">
            Dashboard
          </div>

          <div className="flex flex-col gap-1">
            {MENU_ITEMS.map(({ label, path }) => (
              <NavLink
                key={path}
                to={path}
                className={({ isActive }) =>
                  clsx(
                    'rounded-md px-3 py-2 text-sm transition-colors',
                    isActive
                      ? 'bg-perception-black-500 text-white'
                      : 'text-perception-gray-400 hover:bg-perception-black-700 hover:text-white',
                  )
                }
              >
                {label}
              </NavLink>
            ))}
          </div>
        </div>
      </Panel>

      <div className="min-w-0 flex-1">
        <Routes>
          <Route index element={<Navigate to="detections" replace />} />
          <Route path="detections" element={<VeralliaDashboardDetections />} />
          <Route
            path="last-shift-report"
            element={<VeralliaDashboardLastShiftReport />}
          />
          <Route path="statistics" element={<VeralliaDashboardStatistics />} />
          <Route
            path="defect-catalogue"
            element={<VeralliaDashboardDefectCatalogue />}
          />
          <Route path="*" element={<Navigate to="detections" replace />} />
        </Routes>
      </div>
    </div>
  );
};